
import { useQuery } from '@tanstack/react-query';
import { getCompanyMembers } from '@/services/companyMemberService';
import { useCompanyState } from '@/hooks/useCompanyState';
import { useAuth } from '@/context/AuthContext';

export function useCompanyMembers() {
  const { user } = useAuth();
  const { activeCompany } = useCompanyState(user?.id);

  return useQuery({
    queryKey: ['company-members', activeCompany?.id],
    queryFn: async () => {
      if (!activeCompany?.id) return [];
      return getCompanyMembers(activeCompany.id);
    },
    enabled: !!activeCompany?.id,
  });
}
